import { put, takeEvery } from 'redux-saga/effects';

import oWnApi from 'utils/WnApi';
import userProfileApiDataNormalizer from '../../MyProfile/redux/apiDataNormalizers';
import * as profileActions from './actions';

function* getProfile({ payload: { lookupId, resolve, reject } }) {
  const oResponse = yield oWnApi.get(`constituents/${lookupId}`);
  if (oResponse.status === 200) {
    const oProfile = yield userProfileApiDataNormalizer.validate(
      oResponse.data.DATA
    );
    yield put(profileActions.set(oProfile));
    resolve('Success');
  } else {
    reject('Error');
  }
}

export default function* watchProfileExternalView() {
  yield takeEvery('ProfileExternalView/GET', getProfile);
}
